import { functions } from '../utilities/firebase'

const validateUserProfileUserNameAvailable = async (userName) => {
	try {
		const { data: result } = await functions.httpsCallable('isUserNameAvailable')({ userName })
		return result.available
	} catch (ex) {} // eslint-disable-line no-empty
	return false
}

export default validateUserProfileUserNameAvailable



// WEBPACK FOOTER //
// ./src/dataservices/validateUserProfileUserNameAvailable.js